import type {NonMassFoodQuantityUnit} from './food-quantity.value-object';
import type {ProductId} from './product-id.value-object';

export const LINE_INGREDIENT_SOURCES = ['user_product', 'open_food_facts'] as const;

export type LineIngredientSource = (typeof LINE_INGREDIENT_SOURCES)[number];

export type LineIngredientServingUnit = NonMassFoodQuantityUnit;

/** Weight of one unit or serving of a user product; null for Open Food Facts rows. */
export type LineIngredientServing = {
  readonly unit: LineIngredientServingUnit;
  readonly grams: number;
};

export type LineIngredientCandidate = {
  readonly source: LineIngredientSource;
  readonly name: string;
  readonly brand: string | null;
  readonly barcode: string | null;
  readonly kcalPer100g: number;
  readonly proteinPer100g: number;
  readonly carbsPer100g: number;
  readonly fatPer100g: number;
  readonly serving: LineIngredientServing | null;
  /** The matched user product's id; null for an Open Food Facts hit. */
  readonly productId: ProductId | null;
};
